



























































































































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import VideoRecorder from "@/components/VideoRecorder.vue";

export interface VideoRecorderClass {
  ask(question: any): void;
  startRecording(): void;
  stopRecording(): void;
  countDown(): void;
  playAnswer(index: number): void;
  changeMode(mode: string): void;
}

@Component({
  components: {
    VideoRecorder
  }
})
export default class Interview extends Vue {
  @Prop({ default: "" })
  readonly iid!: string;

  @Ref("recorder") readonly recorder!: VideoRecorderClass;

  finished = false;
  fullsize = true;
  currentQuestion = 0;
  currentTime = 0;

  get questions(): any[] {
    if (this.interview && this.interview.questions) {
      return this.interview.questions;
    }
    return [];
  }

  get interview(): any {
    return this.$store.state.selectedInterview;
  }

  get time(): string {
    return (
      this.questions[this.currentQuestion].time - this.currentTime + " segs"
    );
  }

  created() {
    this.$store.dispatch("bindSelectedInterview", { interviewId: this.iid });
  }
  
  public toggleView() {
    this.fullsize = !this.fullsize;
  }
  public askQuestion(index: number) {
    console.log("ASK Question:" + index);
    this.recorder.ask(this.questions[index]);
  }
  public playAnswer(index: number) {
    this.currentQuestion = index;
    this.recorder.playAnswer(this.questions[index].recording);
  }
  public record() {
    this.recorder.startRecording();
  }
  public restartInterview() {
    this.currentQuestion = 0;
    this.finished = false;
    this.startInterview();
  }
  public startInterview() {
    //this.recorder.resetQuestions();
    this.recorder.changeMode('recorder');
    this.askQuestion(this.currentQuestion);
  }
  public recorderReady() {
    if (!this.finished) {
      this.startInterview();
    }
  }
  public stopRecording() {
    this.finished = true;
  }
  public recordingFinished($event: any) {
    console.log("Recording finished: ");
    console.log($event);
    if ($event.recording) {
      this.questions[this.currentQuestion].recording = $event.recording;
    }
    this.currentQuestion++;
    console.log(this.currentQuestion);
    console.log(this.questions.length);
    console.log(this.questions);
    this.finished = this.currentQuestion >= this.questions.length || $event.action == 'stop_interview';
    if (this.finished) {
      this.currentQuestion = 0;
    }
    console.log("finished:" + this.finished);
    if (this.finished) {
      this.recorder.changeMode('player');
    } else {
      this.askQuestion(this.currentQuestion);
    }
  }
}
